<template>
  <div class="app">
    <el-tabs type="border-card" @tab-click="tabs">
      <el-tab-pane label="日数据">
        <AccountDay
          ref="day"
          @download="download"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="月数据">
        <report-month
          ref="month"
          @download="download"
        />
      </el-tab-pane>
      <el-tab-pane label="年数据">
        <report-year
          ref="year"
          @download="download"
        />
      </el-tab-pane> -->
    </el-tabs>
    <Display
      v-if="isDisplay"
      :start="start"
      :end="end"
      :complete="complete"
      @completeFunc="(isDisplay = false),(complete = false)"
    />
  </div>
</template>

<script>
import AccountDay from './accountDay'
// import ReportMonth from './reportMonth'
// import ReportYear from './reportYear'
// import XLSX from 'xlsx'
import Display from './components/display/index.vue'
// import { getFormData } from '@/api/report/wechatUsers.js'
export default {
  name: 'Index',
  components: {
    // ReportYear,
    // ReportMonth,
    // ReportDay,
    AccountDay,
    Display
  },
  data() {
    return {
      isDisplay: false,
      start: {
        x: null,
        y: null
      },
      end: {
        x: null,
        y: null
      },
      complete: false,
      showFlag: 1
    }
  },
  mounted() {
    this.$refs.day.getList()
    this.$refs.day.getSelectListData()
    this.$refs.day.getSelectListDatar()
  },
  methods: {
    // async exportExcelByField(headerName, fieldsKey, dataSource, fileName) {
    //   const tableData = [headerName]
    //   const commonField = []
    //   const specialField = []
    //   fieldsKey.forEach(field => {
    //     field.indexOf('*') === -1 ? commonField.push(field) : specialField.push(field.substr(1, field.length))
    //   })

    //   dataSource.forEach(item => {
    //     const rowData = []
    //     commonField.forEach(field => {
    //       rowData.push(item[field])
    //     })

    //     specialField.forEach(field => {
    //       rowData.push(this.formatDate(item[field]))
    //     })
    //     tableData.push(rowData)
    //   })
    //   const ws = XLSX.utils.aoa_to_sheet(tableData)
    //   const wb = XLSX.utils.book_new()
    //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    //   await XLSX.writeFile(wb, fileName + '.xlsx')
    //   setTimeout(() => {
    //     this.complete = true
    //   }, 6000)
    // },
    // async download(ifon, ifonId = {}) {
    //   if (this.isDisplay) {
    //     return
    //   }
    //   this.isDisplay = true
    //   const x = document.documentElement.clientWidth
    //   const y = document.documentElement.clientHeight / 2
    //   this.start = {
    //     x: ifon.x,
    //     y: ifon.y
    //   }
    //   this.end = {
    //     x,
    //     y
    //   }
    //   const obj = await getFormData(ifonId)
    //   const tableHeader = obj.data.data[0]
    //   const tableKey = ['novel_name', 'account_name', 'cost', 'fans', 'new_user_recharge', 'new_user_roi']

    //   const tableBody = obj.data.data.slice(1)
    //   this.exportExcelByField(tableHeader, tableKey, tableBody, '表格')
    // },
    tabs(tab) {
      // console.log(tab)
      this.isDisplay = false
      this.start = { x: null, y: null }
      this.end = { x: null, y: null }
      this.complete = false
      // 获取tab month 和 year 的列表数据
      // console.log(tab)
      if (tab.index === '0') {
        this.$refs.day.getList()
        this.$refs.day.getSelectListData()
      } else if (tab.index === '1') {
        this.$refs.month.getList()
        this.$refs.month.getSelectListData()
      } else if (tab.index === '2') {
        this.$refs.year.getList()
        this.$refs.year.getSelectListData()
      }
    }
  }
}
</script>

<style scoped lang="less">
.app {
  margin: 20px 20px;
}
</style>
